import type { ReactElement } from 'react'
import { type UnsavedCustomField } from '@terros/common'
import { useNavigate, createFileRoute } from '@tanstack/react-router'
import { useAddCustomField, useSafeCurrentWorkflow, useTranslation } from '@front/model'
import { ButtonSave, Page } from '@components'
import { useCustomFieldForm } from './util'
import { CustomFieldForm } from './Form'

function AddCustomField(): ReactElement {
  const { t } = useTranslation()

  const wf = useSafeCurrentWorkflow()
  const form = useCustomFieldForm({
    tableType: 'Account',
    fieldType: 'string',
    label: '',
    workflowIds: wf ? [wf.workflow.id] : undefined,
  })
  const { isDirty, onSubmit } = form
  const { add, isAdding } = useAddCustomField()

  const navigate = useNavigate()

  const submit = async (values: UnsavedCustomField): Promise<void> => {
    const cleaned = {
      ...values,
      workflowIds: values.tableType !== 'Account' ? undefined : values.workflowIds,
    }
    await add(cleaned)
    navigate({ to: '/settings/customField' })
    form.resetDirty()
  }

  return (
    <form className='w-full' onSubmit={onSubmit(submit)}>
      <Page>
        <Page.Heading back title={t('Add Custom Field')}>
          <ButtonSave disabled={!isDirty()} loading={isAdding} type='submit' />
        </Page.Heading>
        <Page.Content scrollArea>
          <CustomFieldForm form={form} />
        </Page.Content>
      </Page>
    </form>
  )
}

export const Route = createFileRoute('/settings/customField_/add/')({
  component: AddCustomField,
})
